import { render, staticRenderFns } from "./DataScreen.vue?vue&type=template&id=2d3f5c2d&scoped=true"
import script from "./DataScreen.vue?vue&type=script&lang=js"
export * from "./DataScreen.vue?vue&type=script&lang=js"
import style0 from "./DataScreen.vue?vue&type=style&index=0&id=2d3f5c2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f5c2d",
  null
  
)

export default component.exports